import React from 'react';

import { CSSProperties } from 'react';
import { Property } from 'csstype';
import {isNullOrUndefined} from "../../utils";


type FlexDirectionProperty = Property.FlexDirection


interface ButtonGroupInterface {
    onChange?: () => void;
    style?: CSSProperties;
    direction?: FlexDirectionProperty;
}
interface ItemInterface {
    disabled?: boolean;
    style?: CSSProperties;
    onClick?: () => void;
}

type ButtonGroupProps = ButtonGroupInterface  & React.PropsWithChildren;
type ItemProps = ItemInterface  & React.PropsWithChildren;

const DEFAULT_BUTTONGROUP_STYLE = (flexDirection: FlexDirectionProperty): CSSProperties => ({
    display: 'flex',
    flexDirection: flexDirection,
    borderBottom: '1px solid #e9e9e9',
    borderTop: '1px solid #e9e9e9',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid #e9e9e9',
    borderBottomLeftRadius: '4px',
    borderTopLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    borderTopRightRadius: '4px',
});

const DEFAULT_ITEM_STYLE: CSSProperties = {
    paddingRight: '5px',
    paddingLeft: '5px',
    display: 'flex',
    cursor:  'pointer',
};

const DISABLED_STYLE = {
    backgroundColor: '#f1f1f1',
    color: 'light-gray',
    cursor: 'not-allowed'
};

export const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
    const {direction} = props;
    const theDirection: FlexDirectionProperty = direction ?? 'row';
    const currentStyle = props.style ?? DEFAULT_BUTTONGROUP_STYLE(theDirection);
    return (
        <div
            style={currentStyle}
        >
            {props.children}
        </div>
    );
};

export const Item: React.FC<ItemProps> = (props) => {
    let optStyle = props.style ?? {};
    let currentStyle = {...DEFAULT_ITEM_STYLE, ...optStyle};
    currentStyle =
        (!isNullOrUndefined(props.disabled) && props.disabled) ? {...currentStyle, ...DISABLED_STYLE} : currentStyle;

    return (
        <div
            style={currentStyle}
            onClick={() => {
                if (isNullOrUndefined(props.disabled) || (!isNullOrUndefined(props.disabled) && !props.disabled)) {
                    props.onClick && props.onClick();

                }
                return;
            }}
        >
            {props.children}
        </div>
    );
};